import React from 'react';
import LiceList from "../../../../components/Operation/LiceList";
import TransportInfo from "../../../../components/Popup/PopupOpInfo/Info/Transport/TransportInfo";
import { getSubOfTransport } from "../../../../components/Popup/PopupOpInfo/constants";
import { transportSteps } from "../../../../util/varibles/constants";
import { durationTxtByStartAndFinish, firstLetter, formatNumber } from "../../../../util/varibles/global";
import { IOperation2, ITransport2 } from "../../../../util/varibles/interface";
import { getTotalAmountAndTotalWeight } from "../../../PlanOperationPage/util";
import Checklists from "../../_components/Checklists";
import FishDisease from "../../_components/FishDisease";
import Operation from "../../_components/Operation";
import stylesOp from '../../_components/Operation/style.module.scss';
import OperationTime from "../../_components/OperationTime";
import Route from "../../_components/Route";
import Vessel from "../../_components/Vessel";
import ViewNote from "../../_components/ViewNote";
import WrapperActivityLog from "../../_components/WrapperActivityLog";
import stylesContainer from "../../style.module.scss";

interface IProps {
    data: IOperation2<ITransport2>
    isOwn: boolean
}

const Transport: React.FC<IProps> = ({ data, isOwn }) => {
    const {
        source,
        destination,
        sub_operations = [],
        sub_destinations,
        diseases,
        note = ''
    } = data.operation;

    const { total_weight } = getTotalAmountAndTotalWeight(sub_operations);
    const { activity_log } = data;
    const est_start_time = activity_log[0].est_start_time;
    const est_finish_time = activity_log[activity_log.length - 1].est_start_time;

    const activityLog = activity_log.reduce((list: any, item: any, index: number) => {

        const value = { ...item, steps: [transportSteps[index]], index };
        return [...list, { id: index, list: [value] }];
    }, []);

    const { capacity = 0 } = data.vessel || {};
    const { sub, total } = getSubOfTransport(sub_operations, sub_destinations);
    const isNote = note.length === 0;

    return <div className='col-span-2 pb-3'>
            <div className='grid grid-cols-1 items-stretch gap-[15px] min-[901px]:grid-cols-[minmax(0,2fr)_minmax(290px,1fr)] mb-[15px]'>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Operation {...{ isNote }}>
                <div className={stylesOp['info-line']}>
                    <span>Operation type:</span>
                    <span>Transport</span>
                </div>
                <div className={stylesOp['info-line']}>
                    <span>Smolt site, site: </span>
                    <span>
                        {firstLetter(source?.name)}
                        <span
                            className={[stylesContainer['arrow-right'], 'mr-1'].join(' ')}>&#8594;</span>
                        {firstLetter(destination?.name)}
                    </span>
                </div>
                <OperationTime activity_log={activity_log} />
                <div className={stylesOp['info-line']}>
                    <span>Planned duration: </span>
                    <span>{durationTxtByStartAndFinish(est_start_time, est_finish_time)}</span>
                </div>
                <div className={stylesOp['info-line']}>
                    <span>Est. sum weight: </span>
                    <span>
                        {formatNumber(Math.round(total_weight / 1000) / 1000)} t
                        {` (${Math.round(total_weight / capacity * 100)}%)`}
                    </span>
                </div>
                <FishDisease diseases={diseases || []} units={sub_operations} wrapperClass='mb-[5px]' />
                <LiceList diseases={diseases || []} />
                <TransportInfo {...{ data: sub, total }} />
                <ViewNote data={data} isOwn={isOwn} note={note} />
                    </Operation>
                </div>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Checklists />
                </div>
            </div>
            <div className='grid grid-cols-1 items-stretch gap-[15px] min-[901px]:grid-cols-[minmax(0,2fr)_minmax(290px,1fr)] mb-[15px]'>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Vessel />
                </div>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <WrapperActivityLog
                        isOwn={isOwn}
                        data={data}
                        activity_log={activityLog}
                        activity_log_root={activity_log}
                    />
                </div>
            </div>
            <Route />
    </div>;
};

export default Transport;
